import { forwardRef, useState } from "react";

/*eslint-disable */

declare const window: any;

interface ModelosVehiculosComponentProps {
  modelos: any;
  reserva: any;
}

const ModelosVehiculosComponent = forwardRef<
  HTMLDivElement,
  ModelosVehiculosComponentProps
>(({ modelos, reserva }, ref) => {
  
  const [selectedVersion, setSelectedVersion] = useState(0);
  const [selectedVersionColor, setSelectedVersioncolor] = useState(0);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="modelos-vehiculos-detail-component" ref={ref}>
      <div className="title-modelos-vehiculos-detail-component">
        Más de una posibilidad en tu Hyundai
      </div>
      <div className="version-modelos-vehiculos-detail-component">
        {modelos?.modelos?.map((model: any, index: number) => (
          <div
            className={`item-version-modelos-vehiculos-detail-component ${
              model.title === modelos?.modelos[selectedVersion]?.title
                ? "active"
                : ""
            }`}
            onClick={() => setSelectedVersion(index)}
          >
            {model.title}
          </div>
        ))}
      </div>
      <div className="name-version-modelos-vehiculos-detail-component">
        Versión {modelos?.modelos[selectedVersion]?.title}
      </div>
      <div className="precio-version-modelos-vehiculos-detail-component">
        Disponible desde{" "}
        {formatCurrency(modelos?.modelos[selectedVersion]?.price)} *
      </div>
      <div className="asset-color-version-modelos-vehiculos-detail-component">
        <div className="asset-version-modelos-vehiculos-detail-component">
          {modelos?.modelos[selectedVersion]?.colors[selectedVersionColor]
            .image !== null ? (
            <img
              src={
                `https://manager.hyundaicolombia.co/${modelos?.modelos[selectedVersion]?.colors[selectedVersionColor]
                  .image?.url
              }`}
              alt=""
            />
          ) : null}
        </div>
        <div className="control-color-version-modelos-vehiculos-detail-component">
          <div
            className="colores-control-color-version-modelos-vehiculos-detail-component"
            style={
              modelos?.modelos[selectedVersion]?.colors?.length === 1
                ? { justifyContent: "center" }
                : {}
            }
          >
            {modelos?.modelos[selectedVersion]?.colors.map(
              (color: any, e: number) => (
                <div
                  className={
                    modelos?.modelos[selectedVersion]?.colors[
                      selectedVersionColor
                    ].name === color.name
                      ? "active"
                      : ""
                  }
                  style={{
                    backgroundColor: color.color,
                    border: `2px solid ${color.color}`,
                  }}
                  onClick={() => setSelectedVersioncolor(e)}
                ></div>
              )
            )}
          </div>
          <div className="title-control-color-version-modelos-vehiculos-detail-component">
            {
              modelos?.modelos[selectedVersion]?.colors[selectedVersionColor]
                .name
            }
          </div>
          <div className="politica-control-color-version-modelos-vehiculos-detail-component">
            *Los valores y precios publicados son de referencia y pueden variar
            sin previo aviso. Las imágenes son ilustrativas, algunas
            características de los vehículos de las imágenes pueden variar.
          </div>
        </div>
      </div>
      <div className="caracteristica-version-modelos-vehiculos-detail-component">
        {modelos?.modelos[selectedVersion]?.features.map(
          (item: any, index: number) => (
            <div className="item-caracteristica-version-modelos-vehiculos-detail-component">
              <div className="title-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.title}
              </div>
              <div className="description-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.description}
              </div>
            </div>
          )
        )}
      </div>
      {reserva && reserva.length > 0 ? (
        <a
          href={reserva}
          target="_blank"
          className="compara-version-modelos-vehiculos-detail-component"
        >
          Compara las versiones
        </a>
      ) : null}
    </div>
  );
});

export default ModelosVehiculosComponent;
